import React from 'react';

import { ActionInputFormBlock } from './blocks/ActionInputForm';
import { ActionButtonsBlock } from './blocks/ActionButtons';
import { MarkdownTextBlock } from './blocks/MarkdownText';
import type { AnswerBlock, AnswerState, RedirectRule } from './types';

export interface AnswerBlockProps {
  block: AnswerBlock;
  redirectRules?: RedirectRule[];
  state: AnswerState;
}

export function AnswerBlock({ block, redirectRules, state }: AnswerBlockProps) {
  switch (block.type) {
    case 'markdown-text':
      return <MarkdownTextBlock block={block} redirectRules={redirectRules} state={state} />;
    case 'action-buttons':
      return <ActionButtonsBlock block={block} />;
    case 'action-input-form':
      return <ActionInputFormBlock block={block} />;
    default:
      return null;
  }
}
